import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "/Users/guoshengli/Documents/vue/kexin-qiye/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import { login as _login, logout as _logout, getInfo as _getInfo, get_employee_auth, get_organization_list as _get_organization_list, modify_password, codeLogin as _codeLogin, getSMS as _getSMS, getPolarSMS as _getPolarSMS, getResetSms as _getResetSms } from '@/api/user';
import { query_user_state } from '@/api/account';
import { getToken, setToken, removeToken } from '@/utils/auth';
import router, { resetRouter } from '@/router';
import Cookies from 'js-cookie';
import { Message } from 'element-ui';
import store from '@/store';
var state = {
  token: getToken(),
  name: '',
  roles: [],
  storeLength: localStorage.getItem('storeLength') || 0,
  organizationInfo: JSON.parse(localStorage.getItem('organizationInfo')) || {},
  // 企业相关信息
  loginAccount: localStorage.getItem('loginAccount'),
  userCode: localStorage.getItem('userCode'),
  superAdminFlag: localStorage.getItem('superAdminFlag') || '',
  selectedStore: JSON.parse(localStorage.getItem('selectedStore')) || null
};
var mutations = {
  SET_STORE_LENGTH: function SET_STORE_LENGTH(state, num) {
    localStorage.setItem('storeLength', num);
    state.storeLength = num;
  },
  SET_ORGANIZATION_INFO: function SET_ORGANIZATION_INFO(state, info) {
    localStorage.setItem('organizationInfo', JSON.stringify(info));
    state.organizationInfo = info;
  },
  SET_TOKEN: function SET_TOKEN(state, token) {
    state.token = token;
  },
  SET_LOGINACCOUNT: function SET_LOGINACCOUNT(state, loginAccount) {
    localStorage.setItem('loginAccount', loginAccount);
    state.loginAccount = loginAccount;
  },
  SET_ROLES: function SET_ROLES(state, roles) {
    state.roles = roles;
  },
  SET_USER_CODE: function SET_USER_CODE(state, data) {
    localStorage.setItem('userCode', data);
    state.userCode = data;
  },
  SET_SUPER_ADMIN_FLAG: function SET_SUPER_ADMIN_FLAG(state, data) {
    localStorage.setItem('superAdminFlag', data);
    state.superAdminFlag = data;
  },
  SET_SELECTED_STORE: function SET_SELECTED_STORE(state, store) {
    localStorage.setItem('selectedStore', JSON.stringify(store));
    state.selectedStore = store;
  }
};
var actions = {
  // 账号登录
  login: function login(_ref, userInfo) {
    var commit = _ref.commit;
    return new Promise(function (resolve, reject) {
      _login(userInfo).then(function (response) {
        var data = response.data; // 设置token

        commit('SET_TOKEN', data.token); // 设置用户名

        commit('SET_LOGINACCOUNT', data.userName);
        setToken(data.token);
        commit('SET_USER_CODE', data.userCode); // 把企业审核状态存储到本地
        // merchantAuditStatus  企业审核状态，0：未注册，1：未提交，2：审核中，3：审核成功，4：审核失败

        localStorage.setItem('merchantAuditStatus', data.merchantAuditStatus);
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // 验证码登录
  codeLogin: function codeLogin(_ref2, userInfo) {
    var commit = _ref2.commit;
    return new Promise(function (resolve, reject) {
      _codeLogin(userInfo).then(function (res) {
        if (res.code === 34023) {
          // 用户验证码登录时 code为34023时 默认跳转到注册页面
          resolve(res);
          return;
        }

        var data = res.data; // 设置token

        commit('SET_TOKEN', data.token); // 设置用户名

        commit('SET_LOGINACCOUNT', data.userName);
        setToken(data.token);
        commit('SET_USER_CODE', data.userCode); // 把企业审核状态存储到本地
        // merchantAuditStatus  企业审核状态，0：未注册，1：未提交，2：审核中，3：审核成功，4：审核失败

        localStorage.setItem('merchantAuditStatus', data.merchantAuditStatus);
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // 获取验证码
  getSMS: function getSMS(_ref3, userInfo) {
    var commit = _ref3.commit;
    return _getSMS(userInfo);
  },
  // 获取验证码
  getPolarSMS: function getPolarSMS(_ref4, data) {
    var commit = _ref4.commit;
    return _getPolarSMS(data);
  },
  // get user info
  getInfo: function getInfo(_ref5) {
    var commit = _ref5.commit,
        state = _ref5.state,
        dispatch = _ref5.dispatch;
    dispatch('tagsView/delAllViews', null, {
      root: true
    });
    return new Promise(function (resolve, reject) {
      if (!JSON.parse(localStorage.getItem('organizationInfo')).organizationCode) {
        var roles = [];
        commit('SET_ROLES', roles);
        resolve({
          roles: roles
        });
        return;
      } else {
        _getInfo({
          organizationCode: JSON.parse(localStorage.getItem('organizationInfo')).organizationCode
        }).then(function (res) {
          if (!res.data) {
            Promise.reject(new Error('Verification failed, please Login again.'));
          }

          var data = res.data;
          var roles = data.resourceList.map(function (item) {
            return item.resourceCode;
          }); // roles must be a non-empty array

          if (!roles || roles.length <= 0) {
            Promise.reject(new Error('getInfo: roles must be a non-null array!'));
            Message({
              message: '请给账号所属角色配置权限',
              type: 'error'
            });
            store.dispatch('user/logout').then(function () {// location.reload()
            }).catch(function (err) {
              console.log(err);
            });
            return;
          }

          commit('SET_SUPER_ADMIN_FLAG', res.data.superAdminFlag);
          commit('SET_ROLES', roles);
          resolve({
            roles: roles
          });
        }).catch(function (error) {
          reject(error);
        });
      }
    });
  },
  getEmployeeAuth: function getEmployeeAuth(_ref6) {
    var commit = _ref6.commit,
        state = _ref6.state,
        dispatch = _ref6.dispatch;
    dispatch('tagsView/delAllViews', null, {
      root: true
    });
    return new Promise(function (resolve, reject) {
      get_employee_auth().then(function (res) {
        if (!res.data) {
          Promise.reject(new Error('Verification failed, please Login again.'));
        }

        var data = res.data;
        var roles = data.resourceCodeList; // roles must be a non-empty array

        if (!roles || roles.length <= 0) {
          Promise.reject(new Error('getInfo: roles must be a non-null array!'));
          Message({
            message: '请给账号所属角色配置权限',
            type: 'error'
          });
          store.dispatch('user/logout').then(function () {// location.reload()
          }).catch(function (err) {
            console.log(err);
          });
          return;
        }

        commit('SET_SUPER_ADMIN_FLAG', data.superAdminFlag);
        commit('SET_USER_CODE', data.userCode);
        commit('SET_ROLES', roles);
        commit('SET_ORGANIZATION_INFO', data.orgInfo);
        commit('chatUser/SET_USER_ID', data.orgInfo.organizationCode, {
          root: true
        });
        resolve({
          roles: roles
        });
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // 获取组织列表
  get_organization_list: function get_organization_list(_ref7) {
    var commit = _ref7.commit,
        state = _ref7.state;
    return new Promise(function (resolve, reject) {
      _get_organization_list().then(function (res) {
        // 1-企业  2-门店  3-组织
        var data1 = [];
        var data2 = [];
        var data3 = [];
        res.data.forEach(function (item) {
          if (item.organizationType === 1) {
            data1.push(item);
          } else if (item.organizationType === 2) {
            data2.push(item);
          } else {
            data3.push(item);
          }
        });
        commit('SET_STORE_LENGTH', data2.length);
        resolve({
          data1: data1,
          data2: data2,
          data3: data3,
          data: res
        });
      }).catch(function (err) {
        reject(err);
      });
    });
  },
  // user logout
  logout: function logout(_ref8) {
    var commit = _ref8.commit,
        state = _ref8.state,
        dispatch = _ref8.dispatch,
        rootState = _ref8.rootState;
    return new Promise(function (resolve, reject) {
      if (state.token) {
        _logout(state.token).then(function () {
          commit('SET_TOKEN', '');
          commit('SET_ROLES', []);
          removeToken();
          router.push('/login');
          resetRouter();
          dispatch('tagsView/delAllViews', null, {
            root: true
          });

          if (rootState.chatUser.isLogin) {
            dispatch('chatUser/logout', null, {
              root: true
            }).then(function () {
              localStorage.clear();
            }); // IM 退出登录
          }

          localStorage.clear();
          resolve();
        }).catch(function (error) {
          removeToken();
          router.push('/login');
          resetRouter();
          reject(error);
        });
      } else {
        removeToken();
        router.push('/login');
        resetRouter();
      }

      commit('SET_SELECTED_STORE', null);
    });
  },
  // remove token
  resetToken: function resetToken(_ref9) {
    var commit = _ref9.commit;
    return new Promise(function (resolve) {
      commit('SET_TOKEN', '');
      commit('SET_ROLES', []);
      localStorage.clear();
      removeToken();
      resolve();
    });
  },
  // modify password
  modifyPassword: function modifyPassword(_ref10, payload) {
    var commit = _ref10.commit;
    return new Promise(function (resolve, reject) {
      var mobile = Cookies.get('mobile');
      modify_password(_objectSpread({
        mobile: mobile
      }, payload), {
        isDefaultLoading: true
      }).then(function (response) {
        var code = response.code;

        if (code === 0) {
          // 修改成功
          commit('SET_ROLES', []);
          resetRouter();
          resolve();
        }
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // 查询商户状态
  queryUserState: function queryUserState(_, payload) {
    return query_user_state(payload);
  },
  // 重置密码 获取验证码
  getResetSms: function getResetSms(_ref11, userInfo) {
    var commit = _ref11.commit;
    return _getResetSms(userInfo);
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};